<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_CONTACT')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="contactForm">
            <div class="form-row d-flex align-self-center">
                <label for="contact-telephone" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_TEL_PORT')}}<span
                        class="red-label">*</span></label>
                <div class="d-flex col-md-7">
                    <mat-form-field class="indictif-input" *ngIf="this.typesSelected.situation.code === 'INT'">
                        <span matPrefix>+</span>
                        <input matInput type="text" name="indicatif" formControlName="indicatif"
                            [matAutocomplete]="indicatif1" />
                        <mat-autocomplete #indicatif1="matAutocomplete">
                            <mat-option *ngFor="let ind of indicatifs" [value]="ind">
                                {{ind}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="contactForm.controls.indicatif.touched && contactForm.controls.indicatif.hasError('indicatifUnvalid')">
                            {{texteService.getTexte('ERR_CHAMP_INVALID')}}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex-grow-1">
                        <span matPrefix *ngIf="this.typesSelected.situation.code === 'INT'">|&nbsp;</span>
                        <input id="contact-telephone" matInput type="tel" name="telephone" formControlName="telephone" />
                        <mat-error
                            *ngIf="contactForm.controls.telephone.touched && contactForm.controls.telephone.hasError('required')">
                            {{texteService.getTexte('ERR_CONTACT_TEL_REQUIRED')}}</mat-error>
                        <mat-error
                            *ngIf="contactForm.controls.telephone.touched && contactForm.controls.telephone.hasError('telUnvalid')">
                            {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="contact-telephone2" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_CONTACT_TEL2')}}</label>
                <div class="d-flex col-md-7">
                    <mat-form-field class="indictif-input" *ngIf="this.typesSelected.situation.code === 'INT'">
                        <span matPrefix>+</span>
                        <input matInput type="text" name="indicatif2" formControlName="indicatif2"
                            [matAutocomplete]="indicatif2" />
                        <mat-autocomplete #indicatif2="matAutocomplete">
                            <mat-option *ngFor="let ind of indicatifs" [value]="ind">
                                {{ind}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="contactForm.controls.indicatif2.touched && contactForm.controls.indicatif2.hasError('indicatifUnvalid')">
                            {{texteService.getTexte('ERR_CHAMP_INVALID')}}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex-grow-1">
                        <span matPrefix *ngIf="this.typesSelected.situation.code === 'INT'">|&nbsp;</span>
                        <input id="contact-telephone2" matInput type="tel" name="telephone2" formControlName="telephone2" />
                        <mat-error
                            *ngIf="contactForm.controls.telephone2.touched && contactForm.controls.telephone2.hasError('telUnvalid')">
                            {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="contact-email" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_EMAIL')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="contact-email" matInput type="email" name="email" formControlName="email" />
                    <mat-error
                        *ngIf="contactForm.controls.email.touched && contactForm.controls.email.hasError('required')">
                        {{texteService.getTexte('ERR_CONTACT_EMAIL_REQUIRED')}}</mat-error>
                    <mat-error
                        *ngIf="contactForm.controls.email.touched && contactForm.controls.email.hasError('email')">
                        {{texteService.getTexte('ERR_EMAIL_UNVALID')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <span id="contact-recontact-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_CONTACT_RECONTACT')}}<span
                        class="red-label">*</span></span>
                <mat-radio-group class="col-md-7" name="recontact" formControlName="recontact" aria-labelledby="contact-recontact-label">
                    <mat-radio-button value="am">{{texteService.getTexte('LABEL_CONTACT_RECONTACT_MATIN')}}
                    </mat-radio-button>
                    <mat-radio-button value="pm">{{texteService.getTexte('LABEL_CONTACT_RECONTACT_APRESMIDI')}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </form>
    </mat-card-content>
</mat-card>
